/* import the fontawesome core */
import { library, dom } from '@fortawesome/fontawesome-svg-core'

//https://fontawesome.com/search

/* import specific icons */
import {
    faChevronDown,
    faChevronUp,
    faHouse,

} from '@fortawesome/sharp-solid-svg-icons';

import {
    faMapPin,
    faThumbtack
} from '@fortawesome/pro-solid-svg-icons';


import {
    faUser,
    faEnvelope,
    faChevronsRight,
    faPaperPlane,
    faMessagesQuestion, //<i className="fa-regular fa-messages-question"></i>
    faShieldCat, //<i className="fa-regular fa-shield-cat"></i>

} from '@fortawesome/pro-regular-svg-icons';

import {
    faYoutube,
    faTwitter,
    faDiscord,
    faSquareXTwitter,
    faCcApplePay,
    faCcStripe,
    faPaypal,
    faStripe,
    faGooglePay,
    faCcMastercard,
    faCcVisa,
    faSteamSquare,
    faSteam,
    faSteamSymbol,
    faFacebook,
    faXTwitter
} from '@fortawesome/free-brands-svg-icons';

import {
    faBagShopping,
    faBagsShopping,
    faShoppingBag,
    faBasketShopping,
    faHandPointer,
    faCashRegister,
    faMoonStars,
    faMoon,
    faSunBright,
    faCircleCheck,
    faCircleXmark,
    faArrowUpLeftFromCircle,
    faCartPlus,
    faCartShopping,
    faCartShoppingFast,
    faUsers,
    faComments,
    faTriangleExclamation,

    faSquareTerminal, // <i className="fa-duotone fa-square-terminal"></i>
    faDatabase, //<i className="fa-duotone fa-database"></i>
    faCreditCard, //<i className="fa-duotone fa-credit-card"></i>
    faPuzzle, // <i className="fa-duotone fa-puzzle"></i>
    faGamepadModern, //<i className="fa-duotone fa-gamepad-modern"></i>
    faPanelEws, //<i className="fa-duotone fa-panel-ews"></i>
    faMicrochip, //<i className="fa-duotone fa-microchip"></i>
    faNetworkWired, //<i className="fa-duotone fa-network-wired"></i>


} from '@fortawesome/pro-duotone-svg-icons';
/*
 *  <font-awesome-icon icon="fa-regular fa-gears"></font-awesome-icon>
 */
export default function setupIcons(){
    /* add icons to the library */
    [
        faFacebook,
        faXTwitter,
        faComments,
        faCartPlus,
        faUsers,
        faCartShopping,
        faCartShoppingFast,
        faArrowUpLeftFromCircle,
        faMessagesQuestion, //<i className="fa-regular fa-messages-question"></i>
        faShieldCat, //<i className="fa-regular fa-shield-cat"></i>
        faThumbtack,
        faSteamSquare,
        faSteam,
        faSteamSymbol,
        faChevronUp,
        faSquareTerminal, // <i className="fa-duotone fa-square-terminal"></i>
        faDatabase, //<i className="fa-duotone fa-database"></i>
        faCreditCard, //<i className="fa-duotone fa-credit-card"></i>
        faPuzzle, // <i className="fa-duotone fa-puzzle"></i>
        faGamepadModern, //<i className="fa-duotone fa-gamepad-modern"></i>
        faPanelEws, //<i className="fa-duotone fa-panel-ews"></i>
        faMicrochip, //<i className="fa-duotone fa-microchip"></i>
        faNetworkWired, //<i className="fa-duotone fa-network-wired"></i>
        faSquareXTwitter,
        faCcApplePay,
        faCcStripe,
        faStripe,
        faPaypal,
        faGooglePay,
        faCcMastercard,
        faCcVisa,
        faMapPin,
        faTriangleExclamation,
        faPaperPlane,
        faHouse,
        faChevronsRight,
        faEnvelope,
        faChevronDown,
        faUser,
        faYoutube,
        faTwitter,
        faDiscord,
        faHandPointer,

        faBagShopping,
        faBagsShopping,
        faShoppingBag,
        faBasketShopping,
        faCashRegister,
        faMoonStars,
        faMoon,
        faSunBright,
        faCircleCheck,
        faCircleXmark
    ].forEach(icon => library.add(icon));
    dom.watch();
    console.log("Icons setup 3");
}


